import { Route } from "wouter";
import EmbedForm from "@/pages/public/EmbedForm";
import ForgotPassword from "@/components/ForgotPassword";
import ResetPassword from "@/components/ResetPassword";
import PublicQuote from "@/pages/PublicQuote";
import ProposalView from "@/pages/public/ProposalView";
import { PublicCompiledProposal } from "@/pages/broker/quoting/RFPProposals";

export function PublicRoutes() {
  return (
    <>
      <Route path="/embed/forms/:id" component={EmbedForm} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route path="/reset-password" component={ResetPassword} />
      <Route path="/quote/:token" component={PublicQuote} />
      <Route path="/proposals/:token" component={ProposalView} />
      <Route path="/proposal/:token" component={PublicCompiledProposal} />
    </>
  );
}

